import { CoverageAreaMessages } from "@/messages/coverage-area/coverage-area.messages";
import { FilterType } from "@/types/filter.types";

import { CoverageAreaFilter } from "./types";

export const COVERAGE_AREA_TABLE_COLUMNS = (messages: CoverageAreaMessages) => {
  return [
    messages.cepStartColumn,
    messages.cepEndColumn,
    messages.areaDescriptionColumn,
    messages.freightTypeColumn,
    messages.startWeightColumn,
    messages.endWeightColumn,
    messages.freightChargeOrderColumn,
    messages.freightCostCarrierColumn,
    messages.regionalDeliveryTimeColumn,
    messages.optionsColumn,
  ];
};

export const initialFilterValues: CoverageAreaFilter[] = [
  {
    property: "areaDescription",
    value: "",
    filterType: FilterType.Contains,
  },
];
